(function (Drupal, once) {
  'use strict';

  Drupal.behaviors.konordoMessageModal = {
    attach: function (context) {
      var modal = once('konordo-modal', '[data-konordo-message-modal]', context)[0];
      if (!modal) return;

      var titleEl    = modal.querySelector('[data-modal-title]');
      var backdrop   = modal.querySelector('[data-modal-backdrop]');
      var closeBtn   = modal.querySelectorAll('[data-modal-close]');
      var loadingEl  = modal.querySelector('[data-modal-loading]');
      var successEl  = modal.querySelector('[data-modal-success]');
      var formEl     = modal.querySelector('[data-modal-form]');

      function setState(open, loading, success, formHtml, title) {
        modal.hidden = !open;
        document.body.classList.toggle('overflow-hidden', open);
        if (titleEl) titleEl.textContent = title || '';
        loadingEl.hidden = !loading;
        successEl.hidden = !success;
        formEl.hidden    = success;

        if (typeof formHtml === 'string' && formHtml !== formEl.innerHTML) {
          formEl.innerHTML = formHtml;
          if (window.Drupal && Drupal.attachBehaviors) {
            Drupal.attachBehaviors(formEl);
          }
          bindForm();
        }
      }

      function bindForm() {
        var form = formEl.querySelector('form');
        if (!form || form.dataset.konordoBound) return;
        form.dataset.konordoBound = 'true';
        form.addEventListener('submit', function (e) {
          e.preventDefault();
          e.stopPropagation();
          handleSubmit(form);
        });
      }

      function handleSubmit(form) {
        setState(true, true, false, null, titleEl && titleEl.textContent);
        var action = form.getAttribute('action') || window.location.href;
        var method = (form.getAttribute('method') || 'POST').toUpperCase();
        fetch(action, {
          method: method,
          body: new FormData(form),
          credentials: 'same-origin',
          headers: { 'X-Requested-With': 'XMLHttpRequest' },
          redirect: 'manual'
        })
          .then(function (res) {
            if (res.type === 'opaqueredirect' || res.status === 0 || res.redirected || (res.status >= 300 && res.status < 400)) {
              return { redirected: true };
            }
            return res.text().then(function (html) { return { redirected: false, html: html }; });
          })
          .then(function (result) {
            if (!result || result.redirected) {
              setState(true, false, true, null, titleEl && titleEl.textContent);
              return;
            }
            setState(true, false, false, result.html || '', titleEl && titleEl.textContent);
          })
          .catch(function () {
            setState(true, false, false, '<div class="text-sm text-red-600">Παρουσιάστηκε σφάλμα. Παρακαλούμε δοκιμάστε ξανά.</div>', titleEl && titleEl.textContent);
          });
      }

      function openModal(detail) {
        setState(true, true, false, '', detail.name || '');
        var destination = encodeURIComponent(window.location.pathname + window.location.search);
        fetch('/konordo-messages/form/' + detail.nid + '?destination=' + destination, {
          credentials: 'same-origin',
          headers: { 'X-Requested-With': 'XMLHttpRequest' }
        })
          .then(function (res) { return res.text(); })
          .then(function (html) {
            setState(true, false, false, html, detail.name || '');
          })
          .catch(function () {
            setState(true, false, false, '<div class="text-sm text-red-600">Παρουσιάστηκε σφάλμα. Παρακαλούμε δοκιμάστε ξανά.</div>', detail.name || '');
          });
      }

      function closeModal() {
        setState(false, false, false, '', '');
        formEl.innerHTML = '';
      }

      // Event listeners
      window.addEventListener('konordo-message-open', function (e) {
        openModal(e.detail);
      });

      backdrop.addEventListener('click', closeModal);

      closeBtn.forEach(function (btn) {
        btn.addEventListener('click', closeModal);
      });

      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && !modal.hidden) closeModal();
      });

      // Capture form submits that bubble up (e.g. re-rendered forms)
      modal.addEventListener('submit', function (e) {
        var form = e.target;
        if (form && form.tagName === 'FORM') {
          e.preventDefault();
          e.stopPropagation();
          handleSubmit(form);
        }
      }, true);
    }
  };

})(Drupal, once);
